import React from "react"
import { Button } from 'primereact/button';
import { Dialog } from "primereact/dialog";
import { FormSectionElements, FormSubSections, LOVValues } from "../../entities/formTemplateDataType";
import { Checkbox } from "primereact/checkbox";
import { InputTextarea } from "primereact/inputtextarea";

interface Props {
    ele: FormSectionElements;
    dialogVisible: boolean;
    isEng: boolean;
    callback;

}

export class DialogforExcelComponent extends React.Component<Props> {

    dateTypeFieldList = [];
    constructor(props: Props) {
        super(props);

        let subSection = this.props.ele.parent as FormSubSections;

    }

    generateHtmlString = () => {
        let html = [];
        html.push(
            <>
                {/* @ts-ignore */}
                <Dialog header={this.props.isEng ? "Business Rule for " + this.props.ele.ENUTitle : "Business Rule for " + this.props.ele.FRATitle} footer={this.renderFooter()}
                    visible={this.props.dialogVisible} style={{ width: '50vw' }} onHide={() => this.props.callback(false)}>
                    {this.contentString()}
                </Dialog>
            </>
        );
        return html;
    }

    contentString = () => {
        let htmlString = [];

        htmlString.push(
            <div>
                <div style={{ display: "flex", alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.ele.Sequence}>Freeze the first column</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox inputId={"tbl_" + this.props.ele.Sequence} value={this.props.ele.FreezeColumn}
                            onChange={(e) => { this.props.ele.FreezeColumn = e.checked ? 'Y' : 'N'; this.props.callback() }} checked={this.props.ele.FreezeColumn == 'Y'} />
                    </div>
                </div>

                <div style={{ display: "flex", alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.ele.Sequence}>This table has the summary row</label>
                    </div>
                    <div>
                        {/* @ts-ignore */}
                        <Checkbox inputId={"tbl_" + this.props.ele.Sequence} value={this.props.ele.HasSummaryRow}
                            onChange={(e) => { this.props.ele.HasSummaryRow = e.checked ? 'Y' : 'N'; this.props.callback() }} checked={this.props.ele.HasSummaryRow == 'Y'} />
                    </div>
                </div>

                <div style={{ display: "flex", alignItems: 'center', marginTop: '10px' }}>
                    <div style={{ width: '25%' }}>
                        <label htmlFor={"tbl_" + this.props.ele.Sequence}>Script</label>
                    </div>
                    <div style={{ width: '60%' }}>
                        <InputTextarea className="ontario-input" value={this.props.ele.Script}
                            onChange={(e) => {
                                this.props.ele.Script = e.target.value;
                                this.props.callback();
                            }}></InputTextarea>
                    </div>
                </div>
            </div>

        )
        return htmlString;
    }

    renderFooter = () => {
        return (
            <div>
                {/* @ts-ignore */}
                <Button label="OK" icon="pi pi-check" onClick={() => {
                    this.props.callback(false);
                }} />
                {/* @ts-ignore */}
                <Button label="Cancel" onClick={() => { this.props.callback(false) }} />

            </div>
        );
    }

    render() {
        return (
            this.generateHtmlString()
        )
    }
}
